import { inject } from '@angular/core'
import { ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router'
import { map, withLatestFrom } from 'rxjs/operators'
import { NotificationService } from '../../../services/notification.service'
import { DynamicRoutesService } from '../services/dynamic-routes.service'
import { NavSupportService } from '../services/nav-support.service'
import { AuthFacadeService } from '@dot-it/jml-lib'

/** This gard will check, if the dynamic routes are initialized yet.
 * If so, it will navigate to the '/not-found' route, because the route could not be found.
 * If not, it will navigate to the '/init' route (to wait there for the initialization of the
 * dynamic routes and then repeat the navigation attempt)
 */
export const dynRouteGuard = (next: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
  const router = inject(Router)
  const navSupportService = inject(NavSupportService)
  const dynamicRoutesService = inject(DynamicRoutesService)

  navSupportService.setDesiredUrl(state.url)

  return dynamicRoutesService.dynamicRoutesAreInitialized$.pipe(
    map((initialized) => router.parseUrl(initialized ? '/not-found' : '/init'))
  )
}
